import Vue from 'vue'
import App from './App'
import 'amfe-flexible/index.js'
import './style/base.less'
import './style/common.css'
import './style/font.less'
import { router } from './router'
import store from './store'
import HTTP from './apis'
import Tool from './common/tool'
import validate from './common/validate'
import Enums from './common/enums'
import * as utils from './utils'
import * as AppMethod from './utils/appMethod'
import moment from 'moment'
import Vconsole from 'vconsole'

const envMode = process.env.VUE_APP_CURRENTMODE;
if (envMode != 'production') {
  Vue.use(new Vconsole())
}
console.log(envMode, 'envMode+111')
Vue.prototype.$moment = moment
Vue.prototype.$HTTP = HTTP
Vue.prototype.Tool = Tool
Vue.prototype.$validate = validate
Vue.prototype.$enums = Enums
Vue.prototype.$utils = utils
Vue.prototype.$AppMethod = AppMethod
Vue.prototype.log = function () {
  console.log(...arguments)
}
router.beforeEach((to, from, next) => {
  window.scroll(0, 0);
  next()
})

router.afterEach(() => {
})
new Vue({
  router,
  store,
  el: '#app',
  render: (h) => h(App),
});
